export const CREATE_ORDEN_INGRESO = `
  mutation createOrdenIngreso($ordenIngreso: inputOrdenIngreso!) {
    createOrdenIngreso(ordenIngreso: $ordenIngreso) {
      id
      listMultimedia {
        id
        fileName
      }
    }
  }
`;

export const GET_ORDEN_INGRESO = `
  query getOrdenIngreso($id: String!) {
    getOrdenIngreso(id: $id) {
          id,
          numberOI,
          estado,
          fechaCreacion,
          fechaRecepcion,
          observacion,
          tipoIngreso,
          categoriaIngreso,
          subcategoriaIngreso,
          moneda,
          monto,
          accountStatement{
            id,
            period,
            clientId,
            clientName,
            createdAt,
            updatedAt,
            startDate,
            endDate,
            dueDate,
            accountBalance{
              saldoInicial,
              incrementoCredito,
              creditoTotal,
              montoTotalPI,
              creditoUtilizado,
              montoPagar,
              saldoFinal
            }
          }
          deudor{
            nombre,
            tipo
            id
          },
          listMultimedia{
            id,
            fileName
          }
    }
  }
`;

export const GET_ALL_ORDENES_INGRESO = `
  query{
        getAllOrdenIngreso{
         id,
         montoPagado,
         numberOI,
         estado,
         fechaCreacion,
         fechaRecepcion,
         observacion,
         tipoIngreso,
         categoriaIngreso,
         subcategoriaIngreso,
         moneda,
         monto,
         deudor{
           nombre,
           tipo
           id

         },
         listMultimedia{
         id,
         fileName
         }

         listPagos{
         idTransaccion,
         id,
         monto,
         tipoTrans
         }
         accountStatement{
              id,
              clientId,
              clientName,
              period,
              startDate,
              endDate,
              dueDate,
              createdAt,
              }

        }
      }
`;

export const GET_INCOME_ORDERS_BY_DEUDOR_ID = `
  query getIncomeOrdersByDeudorId($deudorId: String!, $deudorType: String) {
    getIncomeOrdersByDeudorId(deudorId: $deudorId, deudorType: $deudorType) {
         id,
         montoPagado,
         numberOI,
         estado,
         fechaCreacion,
         fechaRecepcion,
         observacion,
         tipoIngreso,
         categoriaIngreso,
         subcategoriaIngreso,
         moneda,
         monto,
         invoiceRelacionadas,
         deudor{
           nombre,
           tipo
           id
         },
         listMultimedia{
          id,
          fileName
         }
         listPagos{
          idTransaccion,
          id,
          monto,
          tipoTrans
         }
         accountStatement{
          id,
          clientId,
          clientName,
          period,
          startDate,
          endDate,
          dueDate,
          createdAt,
        }
      }
    }
`;

export const UPDATE_ORDEN_INGRESO = `
  mutation updateOrdenIngreso($id: String!, $ordenIngreso: inputOrdenIngreso!) {
    updateOrdenIngreso(id: $id, ordenIngreso: $ordenIngreso) {
      id
    }
  }
`;

export const DELETE_ORDEN_INGRESO = `
  mutation deleteOrdenIngreso($id: String!) {
    deleteOrdenIngreso(id: $id) {
      id
    }
  }
`;

export const GET_ALL_ORDENES_INGRESO_FILES = `
query{
        getAllFiles{
          id,
          fileNumber,
          nombreItinerario,
        }
      }
`;
